module.exports = __webpack_public_path__ + "img/skype.52b54482.svg";